<ng-container *ngIf="!inFile; else inFileTemplate">
  <div
    [class.p-20]="!!file"
    [class.section-container]="!coverLaminated"
    [ngClass]="{
      'default-style': styleType === 'default',
      'new-style': styleType === 'new',
    }"
  >
    <h4 class="subtitle mt-0">Acabado del plastificado:</h4>
    <div class="flex flex-row flex-wrap justify-between">
      <ion-button
        *ngFor="let option of settings[Settings.LAMINATION_TYPE].options; let i = index"
        expand="block"
        fill="outline"
        (click)="selectOption(i, Settings.LAMINATION_TYPE)"
        [class.selected]="laminationType === option.value"
        [ngStyle]="{ width: 'calc(calc(' + option.size + '/ 12)* 100% - 10px' }"
        [disabled]="isDisabled(i, Settings.LAMINATION_TYPE)"
        class="option-button"
      >
        <div class="flex flex-col">
          <video *ngIf="option.video" #videoElement loop [src]="option.video" muted></video>
          <div class="bottom-section flex">
            <span>{{ option.title }}</span>
            <span class="custom-radio" [class.selected]="laminationType === option.value"></span>
          </div>
        </div>
      </ion-button>
    </div>
    <hr />

    <div class="mb-2 flex flex-row items-center gap-2">
      <span class="file-text bold"> Grosor del plastificado:</span>
      <ng-container *ngIf="!coverLaminated && !isBindingLaminated">
        <ion-icon
          [id]="'tooltip-icon-lamination-weight-setting'"
          class="tooltip-icon"
          src="assets/icon/info.svg"
        ></ion-icon>
        <ion-popover
          trigger="tooltip-icon-lamination-weight-setting"
          class="info-popover"
          triggerAction="click"
          side="right"
          showBackdrop="true"
          animated="true"
        >
          <ng-template>
            <app-tooltip-info-lamination-weight></app-tooltip-info-lamination-weight>
          </ng-template>
        </ion-popover>
      </ng-container>
    </div>

    <div class="flex flex-col flex-wrap justify-between md:flex-row">
      <ng-container
        *ngFor="
          let option of settings[Settings.LAMINATION_WEIGHT].options;
          let i = index;
          let isEven = even;
          let isLast = last
        "
      >
        <ion-button
          *ngIf="!isDisabled(i, Settings.LAMINATION_WEIGHT)"
          expand="block"
          fill="outline"
          (click)="selectOption(i, Settings.LAMINATION_WEIGHT)"
          [class.selected]="laminationWeight === option.value"
          [ngStyle]="{}"
          [disabled]="isDisabled(i, Settings.LAMINATION_WEIGHT)"
          class="option-button md:w-100 flex flex-grow"
        >
          <div
            class="patata w-100 flex flex-row items-center"
            [ngClass]="isModal ? 'justify-center' : 'justify-between'"
          >
            <div class="flex flex-col" [ngClass]="isModal ? 'items-center' : 'items-between'">
              <span class="weightTitle">{{
                fileService.getLaminationWeightName(option.value, laminationType, coverLaminated || isBindingLaminated)
              }}</span>
              <span *ngIf="!coverLaminated && !isBindingLaminated" class="weightSubtitle"
                >{{ option.title }} micras</span
              >
            </div>
            <span class="custom-radio" [class.selected]="laminationWeight === option.value"></span>
          </div>
        </ion-button>
      </ng-container>
    </div>
    <div *ngIf="!!showButtons" class="mt-4 flex flex-row gap-1.5">
      <ion-button class="flex-grow" color="dark" fill="outline" (click)="closeModal()">Cancelar </ion-button>
      <ion-button class="flex-grow" color="primary" (click)="submit()">Guardar y continuar </ion-button>
    </div>
  </div>
</ng-container>

<ng-template #inFileTemplate>
  <div
    class="container-type flex flex-col items-start justify-between"
    [ngClass]="{
      'default-style': styleType === 'default',
      'new-style': styleType === 'new',
    }"
  >
    <span class="file-text bold mb-2.5">Acabado del plastificado:</span>
    <div class="w-100 mb-2.5 flex flex-row justify-between gap-2.5">
      <ion-radio-group
        [value]="laminationType"
        (ionChange)="changeDocLaminationType($event)"
        class="w-100 flex flex-row flex-wrap gap-2.5"
      >
        <div class="laminationTypeButton flex grow flex-row" [class.selected]="laminationType === 'matte'">
          <img src="assets/images/plastificado-mate.png" alt="" />
          <ion-radio
            mode="md"
            labelPlacement="start"
            justify="space-between"
            alignment="center"
            value="matte"
            class="file-text"
            >MATE
          </ion-radio>
        </div>
        <div class="laminationTypeButton flex grow flex-row" [class.selected]="laminationType === 'gloss'">
          <img src="assets/images/plastificado-brillo.png" alt="" />
          <ion-radio
            mode="md"
            labelPlacement="start"
            justify="space-between"
            alignment="center"
            value="gloss"
            class="file-text"
            >BRILLO
          </ion-radio>
        </div>
      </ion-radio-group>
    </div>
    <div class="mb-2 flex flex-row items-center gap-2">
      <span class="file-text bold"> Grosor del plastificado:</span>
      <ion-icon
        [id]="'tooltip-icon-lamination-weight' + file.id"
        class="tooltip-icon"
        src="assets/icon/info.svg"
      ></ion-icon>
      <ion-popover
        [trigger]="'tooltip-icon-lamination-weight' + file.id"
        class="info-popover"
        triggerAction="click"
        side="right"
        showBackdrop="true"
        animated="true"
      >
        <ng-template>
          <app-tooltip-info-lamination-weight></app-tooltip-info-lamination-weight>
        </ng-template>
      </ion-popover>
    </div>
    <ion-radio-group
      class="flex w-full flex-row flex-wrap justify-between gap-y-0.5"
      [value]="laminationWeight"
      (ionChange)="changeDocLaminationWeight($event)"
    >
      <ng-container
        *ngFor="
          let option of settings[Settings.LAMINATION_WEIGHT].options;
          let i = index;
          let isEven = even;
          let isLast = last
        "
      >
        <ion-radio
          *ngIf="!isDisabled(i, Settings.LAMINATION_WEIGHT)"
          [class.selected]="laminationWeight === option.value"
          [disabled]="isDisabled(i, Settings.LAMINATION_WEIGHT)"
          mode="md"
          labelPlacement="start"
          justify="space-between"
          alignment="center"
          [value]="option.value"
          class="file-text no-margin container-type w-full xl:w-3/6"
        >
          <div class="flex w-full flex-col items-start">
            <span class="weightTitle">{{
              fileService.getLaminationWeightName(option.value, laminationType, coverLaminated || isBindingLaminated)
            }}</span>
            <span *ngIf="!coverLaminated && !isBindingLaminated" class="weightSubtitle">{{ option.title }} micras</span>
          </div>
        </ion-radio>
      </ng-container>
    </ion-radio-group>
  </div>
</ng-template>
